export type FAQItem = {
  question: { en: string; fa: string }
  answer: { en: string; fa: string }
}

export const faqItems: FAQItem[] = [
  {
    question: {
      en: 'How does Trend select the most suitable media for each campaign?',
      fa: 'ترند چگونه مناسب‌ترین رسانه را برای هر کمپین انتخاب می‌کند؟',
    },
    answer: {
      en: 'We select media based on campaign goals, audience behavior, budget, and content type to ensure each campaign is executed on the most effective platform.',
      fa: 'ما انتخاب رسانه را بر اساس هدف کمپین، رفتار مخاطبان، بودجه و نوع محتوا انجام می‌دهیم؛ تا هر کمپین در مناسب‌ترین بستر اجرا شود.',
    },
  },
  {
    question: {
      en: 'How is campaign performance measured and reported?',
      fa: 'عملکرد کمپین‌ها چگونه اندازه‌گیری و گزارش می‌شود؟',
    },
    answer: {
      en: 'All campaigns are analyzed using real-time data, performance dashboards, and detailed reports—from impressions and engagement to final ROI.',
      fa: 'تمام کمپین‌ها با داده‌های واقعی، داشبوردهای عملکرد و گزارش‌های دقیق تحلیل می‌شوند؛ از میزان دیده‌شدن تا تعامل و بازدهی نهایی.',
    },
  },
  {
    question: {
      en: 'On what basis are influencers and media selected?',
      fa: 'اینفلوئنسرها و رسانه‌ها بر چه اساسی انتخاب می‌شوند؟',
    },
    answer: {
      en: 'Selections are made based on brand alignment, audience quality, engagement rates, and performance history, rather than just follower counts.',
      fa: 'انتخاب‌ها بر اساس تناسب با برند، کیفیت مخاطبان، نرخ تعامل و سابقه عملکرد انجام می‌شود؛ نه صرفاً تعداد دنبال‌کننده.',
    },
  },
  {
    question: {
      en: 'Is it possible to run campaigns across multiple platforms simultaneously?',
      fa: 'آیا امکان اجرای هم‌زمان کمپین در چند پلتفرم وجود دارد؟',
    },
    answer: {
      en: 'Yes. Campaigns can be executed in a synchronized manner across social networks, messaging apps, and video platforms.',
      fa: 'بله. کمپین‌ها می‌توانند به‌صورت هماهنگ در شبکه‌های اجتماعی، پیام‌رسان‌ها و پلتفرم‌های ویدیویی اجرا شوند.',
    },
  },
  {
    question: {
      en: 'What stages of campaign management does Trend handle?',
      fa: 'مدیریت کمپین‌ها تا چه مرحله‌ای توسط ترند انجام می‌شود؟',
    },
    answer: {
      en: 'From planning and media selection to execution, coordination, distribution, and final reporting; all campaign stages are managed by the Trend team.',
      fa: 'از برنامه‌ریزی و انتخاب رسانه تا اجرا، هماهنگی، انتشار و گزارش نهایی؛ تمام مراحل کمپین توسط تیم ترند مدیریت می‌شود.',
    },
  },
  {
    question: {
      en: 'How does Trend differ from traditional advertising agencies?',
      fa: 'تفاوت ترند با آژانس‌های تبلیغاتی سنتی چیست؟',
    },
    answer: {
      en: 'Trend executes campaigns based on data, media, and real performance, focusing on transparency, measurement, and continuous optimization.',
      fa: 'ترند کمپین‌ها را بر پایه داده، رسانه و عملکرد واقعی اجرا می‌کند؛ با تمرکز بر شفافیت، اندازه‌گیری و بهینه‌سازی مداوم.',
    },
  },
  {
    question: {
      en: 'How does Trend allocate campaign budgets across media?',
      fa: 'ترند چگونه بودجه کمپین را بین رسانه‌ها تقسیم می‌کند؟',
    },
    answer: {
      en: 'The budget is allocated based on campaign goals, audience behavior, and the performance of each media channel to generate the highest possible ROI.',
      fa: 'بودجه بر اساس هدف کمپین، رفتار مخاطبان و عملکرد هر رسانه برنامه‌ریزی می‌شود؛ تا بیشترین بازدهی ممکن ایجاد شود.',
    },
  },
  {
    question: {
      en: 'What types of brands and businesses collaborate with Trend?',
      fa: 'چه نوع برندها و کسب‌وکارهایی با ترند همکاری می‌کنند؟',
    },
    answer: {
      en: 'We work with a wide range of businesses, from startups to large enterprises, across sectors such as technology, consumer goods, services, healthcare, and entertainment.',
      fa: 'از استارتاپ‌ها تا برندهای بزرگ؛ در حوزه‌هایی مانند فناوری، کالاهای مصرفی، خدمات، سلامت و سرگرمی.',
    },
  },
  {
    question: {
      en: "Are campaigns designed to align with each brand's specific goals?",
      fa: 'آیا کمپین‌ها متناسب با اهداف هر برند طراحی می‌شوند؟',
    },
    answer: {
      en: 'Yes. Every campaign is custom-designed and executed based on the unique needs, target audience, and objectives of each brand.',
      fa: 'بله. هر کمپین بر اساس نیاز، مخاطب و اهداف همان برند طراحی و اجرا می‌شود.',
    },
  },
  {
    question: {
      en: 'What is the process for starting a collaboration and launching a campaign?',
      fa: 'فرآیند شروع همکاری و اجرای کمپین چگونه است؟',
    },
    answer: {
      en: 'Collaboration begins with an initial consultation to review needs and goals, followed by strategy development, media selection, and the final execution plan.',
      fa: 'همکاری با یک جلسه بررسی نیاز و هدف کمپین آغاز می‌شود؛ سپس استراتژی، انتخاب رسانه و برنامه اجرایی طراحی و اجرا خواهد شد.',
    },
  },
]
